import log from 'loglevel';

export function initNavigationElements() {
  toggleMobileMenuOnNavClick();
  toggleMobileSubmenus();
  stabilizeDropdownHover();
  toggleTransparencyOnScroll();


  log.info("Navigation loaded")
}

function toggleMobileMenuOnNavClick() {
  const menuBtn = document.querySelector(".mil-menu-btn");

  if (menuBtn) {
    const navigation = document.querySelector('.mil-navigation');

    menuBtn.addEventListener("click", function () {
        this.classList.toggle('mil-active')
        if (navigation) { navigation.classList.toggle('mil-active') }
    });
  }
}

function toggleMobileSubmenus() {
  const submenuToggles = document.querySelectorAll(".mil-submenu-toggle, .mil-nav-parent");

  submenuToggles.forEach((toggle) => {
    toggle.addEventListener("click", function () {
      const parentItem = this.closest(".mil-has-children");
      const parentControl = parentItem?.querySelector(".mil-nav-parent");
      const plusControl = parentItem?.querySelector(".mil-submenu-toggle");
      const currentStateControl = parentControl || plusControl || this;
      const isExpanded = currentStateControl.getAttribute("aria-expanded") === "true";

      if (parentItem) {
        parentItem.classList.toggle("mil-submenu-open", !isExpanded);
      }

      parentControl?.setAttribute("aria-expanded", String(!isExpanded));
      plusControl?.setAttribute("aria-expanded", String(!isExpanded));
    });
  });
}

function stabilizeDropdownHover() {
  const submenuItems = document.querySelectorAll(".mil-has-children");

  submenuItems.forEach((item) => {
    let closeTimer;

    const open = () => {
      window.clearTimeout(closeTimer);
      item.classList.add("mil-submenu-hover");
    };

    const close = () => {
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(() => {
        if (!item.matches(":hover") && !item.contains(document.activeElement)) {
          item.classList.remove("mil-submenu-hover");
        }
      }, 220);
    };

    item.addEventListener("mouseenter", open);
    item.addEventListener("mouseleave", close);
    item.addEventListener("focusin", open);
    item.addEventListener("focusout", (event) => {
      if (!item.contains(event.relatedTarget)) close();
    });
  });
}

function toggleTransparencyOnScroll() {
  window.addEventListener("scroll", function () {
      const topPanel = document.querySelector(".mil-top-panel.mil-animated");
      const additionalPanel = document.querySelector(".has-additional-panel");

      if (window.scrollY >= 220) {
        if (topPanel) { topPanel.classList.remove("mil-top-panel-transparent") }
        if (additionalPanel) { additionalPanel.classList.add("mil-hide-top") }
      } else {
        if (topPanel) { topPanel.classList.add("mil-top-panel-transparent") }
        if (additionalPanel) { additionalPanel.classList.remove("mil-hide-top") }
      }
  });
}
